





















import { Component, Prop, Vue } from "vue-property-decorator";
import { IProduct } from "@/models/products";
import ObjectNotificationsProvider from "@/components/app/admin/objectNotifications/objectNotificationsProvider.vue";

@Component({
  components: {
    "object-notifications-provider": () =>
      import(
        "@/components/app/admin/objectNotifications/objectNotificationsProvider.vue"
      ),
    "object-notifications-table": () =>
      import(
        "@/components/app/admin/objectNotifications/objectNotificationsTable.vue"
      )
  }
})
export default class AdminProductTriggers extends Vue {
  // Refs
  public $refs!: {
    objectNotificationsProvider: ObjectNotificationsProvider;
  };

  // Props

  @Prop({ required: true })
  public productId!: IProduct["id"];

  // Computed

  public get i18n() {
    return {
      cta: this.$t("_action.add"),
      title: this.$t("_.product_notifications")
    };
  }

  public get i18nTable() {
    return {
      emptyMessage: this.$t(
        "_sentence.object_notifications.no_product_notifications"
      )
    };
  }

  public get canCreate() {
    return this.$userCan("create_object_notification_mapping");
  }

  // Methods

  public openAddObjectNotificationMappingModal() {
    this.$refs?.objectNotificationsProvider?.openAddEditModal();
  }
}
